import { render } from "./callout.vue?vue&type=template&id=6838f0f5&ts=true"
import script from "./callout.vue?vue&type=script&lang=ts"
export * from "./callout.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__